import { useQuery } from "@tanstack/react-query";
import { BASE_API_URL_V2 } from "@/constants";
import fpFetch from "@/services/fpFetch";
import { EntityKind } from "../Dashboard/types";
import {
  keyForSource,
  useRecordDataSource,
} from "../Dashboard/recordDataSource";

export interface ContactEntry {
  id: string;
  name: string;
  title: string | null;
  email: string | null;
  phone: string | null;
}

export interface ContactsResponse {
  contacts: ContactEntry[];
}

export async function fetchContacts(
  entityKind: EntityKind,
  entityId: string
): Promise<ContactsResponse> {
  const response = await fpFetch(
    `${BASE_API_URL_V2}/api/v2/rms/entities/${entityKind}/${entityId}/contacts`
  );
  return response.json();
}

export function useContacts(entityKind: EntityKind, entityId: string) {
  // Read through the record's data source (#13370, round 36c): Appearance's demo record answers
  // from its own rows.
  const source = useRecordDataSource();
  return useQuery({
    queryKey: keyForSource(source, ["rms", "contacts", entityKind, entityId]),
    queryFn: () => source.contacts(entityKind, entityId),
    enabled: !!entityId,
  });
}
